import Cookies from "js-cookie";

export default function extractFeatureFlagsFromCookie() {
    const activeInDevFeatures = Cookies.get("activeInDevFeatures");
    return activeInDevFeatures ? activeInDevFeatures.split(',') : [];
}